import "../../../../content/projects/copycat/copycat.css";
import * as React from 'react';
export default {
  React
};